import { Box, SimpleGrid, Text } from "@chakra-ui/react";
import { FireAlarmDevice } from "../components/FireAlarmDevice.jsx";
import { useLocation } from "react-router-dom";
import React, { useState, useContext, useEffect } from "react";
import { SignalRContext } from "./SignalRContext";

export const FireAlarmPage = () => {
    const { message } = useContext(SignalRContext);
    const [devices, setDevices] = useState([]);
    const location = useLocation();

    // Initialize as empty array by default
    const [fireAlarm, setFireAlarm] = useState([]);

    useEffect(() => {
        let deviceList = [];
        let newFireAlarm = [];

        if (message?.flag === false) {
            newFireAlarm = location.state || [];
        } else {
            deviceList = devices;
            console.log(deviceList);
            newFireAlarm = deviceList.filter((e) => {
                return e?.deviceType === 1;
            });
        }

        setFireAlarm(newFireAlarm);
    }, [message, devices, location.state]);

    useEffect(() => {
        // Trigger the loader to fetch data
        if (message?.flag === true) {
            console.log("flag = " + message.flag);
            setDevices(message.devices || []);
        }
        console.log("SignalR message received in Child2:", message);
    }, [message]);

    return (
        <Box mt="20px" ml="20px" mr="20px">
            <Text mb="20px" ml="5px" fontSize="sm"></Text>
            <SimpleGrid columns={[1, 1, 2, 3, 4, 4, 4]} spacing="10px">
                {fireAlarm?.map((e) => (
                    <FireAlarmDevice key={e.deviceId} device={e} />
                ))}
            </SimpleGrid>
        </Box>
    );
};